import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { FormattedHTMLMessage } from 'react-intl'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'

const InstructionModal = ({ isOpen, toggle, message }) => {
  // Generate unique IDs for accessibility
  const modalId = 'instruction-modal'
  const modalTitleId = 'instruction-modal-title'

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      centered
      id={modalId}
      aria-labelledby={modalTitleId}
      role="dialog"
    >
      <ModalHeader toggle={toggle}>
        <span className="sr-only">
          <FormattedMessage id="global.label.close" defaultMessage="Close" />
        </span>
      </ModalHeader>
      <ModalBody>
        <h2 id={modalTitleId} className="text-center">
          <FormattedMessage id="global.label.instruction" />
        </h2>
        <div className="instruction-content">
          <FormattedHTMLMessage id={message} />
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="w-100">
          <div className="row">
            <div className="col">
              <Button block outline color="light" onClick={toggle} aria-label="Close instructions">
                <FormattedMessage id="global.label.popoverClose" />
              </Button>
            </div>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  )
}

InstructionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
}

export default InstructionModal
